import { LocalLookupService } from '@ofqual/portal-core/core/dataAccess';
import {
 API_HOST_GUIDANCE,
 API_HOST_LCM,
 API_HOST_ORGS,
 API_HOST_REFDATA,
 API_HOST_SEARCH,
 API_HOST_USERS,
} from '../config';
import caseNoteTypeLookups from './json/caseNoteTypeLookups.json';
import communicationTypeLookups from './json/communicationTypeLookups.json';
import { UserService } from './UserService';
import { LcmService } from './LcmService';
import { refDataEndpoints, RefDataService } from './RefDataService';
import { AwardingOrgService } from './AwardingOrgService';
import { KeywordService } from './KeywordService';
import { AwardingOrgSearchService } from './AwardingOrgSearchService';
import { RefDataMatterTypeHierarchyService } from './RefDataMatterTypeHierarchyService';
import { GuidanceService } from './GuidanceService';
import statusLookups from './json/statuses.json';

export const lcmService = new LcmService(API_HOST_LCM);

export const categoryService = new RefDataService(
 API_HOST_REFDATA,
 refDataEndpoints.category,
);
export const directorateService = new RefDataService(
 API_HOST_REFDATA,
 refDataEndpoints.gqVtq,
);
export const projectPolicyCategoryService = new RefDataService(
 API_HOST_REFDATA,
 refDataEndpoints.policyProjectCategory,
);
export const projectPolicySubCategoryService = new RefDataService(
 API_HOST_REFDATA,
 refDataEndpoints.policyProjectSubCategory,
);

export const directorateLookupService = new RefDataService(
 API_HOST_REFDATA,
 refDataEndpoints.lcmDirectorate,
);

export const matterTypeHierarchyLookupService =
 new RefDataMatterTypeHierarchyService(API_HOST_REFDATA);

export const counselCategoryLookupService = new RefDataService(
 API_HOST_REFDATA,
 refDataEndpoints.lcmCounselCategory,
);
export const caseNoteTypeLookupService = new LocalLookupService(
 caseNoteTypeLookups,
);
export const futureEventTypeLookupService = new LocalLookupService(
 communicationTypeLookups,
);
export const statusService = new LocalLookupService(statusLookups);
export const usersService = new UserService(API_HOST_USERS);
export const aoService = new AwardingOrgService(API_HOST_ORGS);
export const keywordService = new KeywordService(API_HOST_LCM);
export const aoServiceSearch = new AwardingOrgSearchService(API_HOST_SEARCH);
export const guidanceService = new GuidanceService(API_HOST_GUIDANCE);
